import React, { useEffect, useState, useRef } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage, languages } from '../../hooks/useLanguage';
import { motion, AnimatePresence } from 'framer-motion';
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const currentLang = languages.find(l => l.code === language);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative z-50" ref={menuRef} data-id="element-244">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium text-gray-700" aria-label="Change language" aria-expanded={isOpen} data-id="element-245">
        <Globe className="w-4 h-4" data-id="element-246" />
        <span className="hidden sm:inline" data-id="element-247">
          {currentLang?.flag} {currentLang?.label}
        </span>
        <span className="sm:hidden" data-id="element-248">{currentLang?.code.toUpperCase()}</span>
      </button>

      <AnimatePresence data-id="element-249">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} data-id="element-250" />
            <motion.div initial={{
          opacity: 0,
          y: -10,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: -10,
          scale: 0.95
        }} transition={{
          duration: 0.15
        }} className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden z-50 min-w-[160px]" data-id="element-251">
              {languages.map(lang => <button key={lang.code} onClick={() => {
            setLanguage(lang.code);
            setIsOpen(false);
          }} className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${language === lang.code ? 'bg-[#10b981]/10 text-[#10b981]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-252">
                  <span className="text-lg" data-id="element-253">{lang.flag}</span>
                  <span data-id="element-254">{lang.label}</span>
                  {language === lang.code && <motion.div layoutId="lang-check" className="ml-auto w-2 h-2 rounded-full bg-[#10b981]" data-id="element-255" />}
                </button>)}
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}